import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ContactData} from '../../../model/contact-data';
import {Observable} from 'rxjs';
import {RestResponse} from '../../../model/rest-response';
import {CorporateTravelData} from '../../../model/corporate-travel-data';
import {environment} from '../../../../environments/environment';

@Injectable()
export class CorporateService {

  constructor(private http: HttpClient) {
  }

  corporateTravel(data: CorporateTravelData, isCorporate: string): Observable<RestResponse> {
    const params = new HttpParams().set('isCorporate', isCorporate);
    return this.http.post<RestResponse>(environment.serverUrl + '/contact-info/corporate', data, {params: params});
  }

  personalTravel(data: ContactData): Observable<RestResponse> {
    return this.http.post<RestResponse>(environment.serverUrl + '/contact-info/personal', data);
  }

  privateJet(data: ContactData): Observable<RestResponse> {
    return this.http.post<RestResponse>(environment.serverUrl + '/contact-info/private-jet', data);
  }

  getPrivateJetQuote(data: any) {
    return this.http.post<RestResponse>(environment.serverUrl + '/contact-info/private-jet-quote', data);
  }
}
